import React from "react";
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
// imgs
import tik from "../../../images/landing/correct.png";

const LandingCard = (props) => {
  return (
    <div className="landing-card">
      <MDBRow className="align-items-center ">
        <MDBCol
          md="12"
          className="d-flex justify-content-top justify-content-center"
        >
          <div className="landing-card-img-box">
            <img
              src={props.img}
              alt="card image"
              className="landing-card-img"
            />
          </div>
        </MDBCol>
        <MDBCol md="12">
          <li className="landing-card-li">
            <img src={tik} alt="check mark" />
            {props.text}
          </li>
          <p className="landing-card-li-desc">{props.desc}</p>
        </MDBCol>
      </MDBRow>
    </div>
  );
};

export default LandingCard;
